import { useState, useEffect } from "react";
import { Branch } from "../types/branch";
import api from "../../../../../features/auth/axiosConfig";

export const useBranchManagement = () => {
  const [branches, setBranches] = useState<Branch[]>([]);
  const [showDeletedBranches, setShowDeletedBranches] = useState(false);
  const [loading, setLoading] = useState(false);

  const fetchBranches = async (showDeleted?: boolean): Promise<void> => {
    try {
      setLoading(true);
      const isDeleted = showDeleted ?? showDeletedBranches;
      const res = await api.get(`/app/pos/v2/branch?is_deleted=${isDeleted}`);
      const branchesData = isDeleted ? res.data.result : res.data.result.filter((branch: Branch) => !branch.isDeleted);
      setBranches(branchesData);
    } catch (error) {
      console.error("Error fetching branches:", error);
    } finally {
      setLoading(false);
    }
  };
  const handleCheckboxChange = () => {
    setShowDeletedBranches((prev) => !prev);
  };

  const deleteBranch = async (branchId: string) => {
    try {
      await api.delete(`/app/pos/v2/branch/${branchId}`);
      setBranches((prev) => prev.filter((branch) => branch._id.$oid !== branchId));
      return true;
    } catch (error) {
      console.error("Error deleting branch:", error);
      return false;
    }
  };

  useEffect(() => {
    fetchBranches(showDeletedBranches);
  }, [showDeletedBranches]);

  return {
    branches,
    showDeletedBranches,
    handleCheckboxChange,
    deleteBranch,
    fetchBranches,
    loading,
  };
};
